<template>
    <button
        type="button"
        class="btn btn-primary font-weight-bolder dm-btn-wizard"
        data-wizard-type="action-submit"
        @click="checkIfStepsCompleteAndSubmit()"
    >
        {{ translate("Preview - you are almost there") }}
        <span class="svg-icon svg-icon-md ml-3">
            <CheckmarkSvg />
        </span>
    </button>

    <modal
        size="xl"
        class="text-left dm-modal dm-terms-and-conditions-modal"
        id="dm-terms-and-conditions-modal"
        :title="modalTitle"
    >
        <div v-if="gdpr_terms">
            <div class="mb-8" v-html="gdpr_terms"></div>
        </div>

        <div v-if="gdpr_privacy_policy">
            <div class="mb-4" v-html="gdpr_privacy_policy"></div>
        </div>

        <div class="form-row mt-6">
            <div class="checkbox-inline">
                <label class="checkbox">
                    <input
                        type="checkbox"
                        name="wizardtc"
                        @change="agree_terms = !agree_terms"
                    />
                    <span></span>
                    <div class="font-weight-bold">
                        {{ translate("I agree to the Terms and Conditions") }}
                    </div>
                </label>
            </div>
        </div>

        <div class="form-row mb-6">
            <div class="checkbox-inline">
                <label class="checkbox">
                    <input
                        type="checkbox"
                        name="wizardtc"
                        @change="agree_privacy_policy = !agree_privacy_policy"
                    />
                    <span></span>
                    <div class="font-weight-bold">
                        {{ translate("I agree to the Privacy Policy") }}
                    </div>
                </label>
            </div>
        </div>

        <div class="text-center mb-6">
            <button
                type="button"
                class="btn btn-primary font-weight-bolder dm-btn-wizard"
                :disabled="!hasAgreedBoth"
                @click="hideModalAndGoToPreview()"
            >
                {{ translate("Confirm") }}
            </button>
        </div>
    </modal>
</template>

<script>
import CheckmarkSvg from "@/svg/CheckmarkSvg.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState } from "pinia";

export default {
    data() {
        return {
            agree_terms: false,
            agree_privacy_policy: false,
            companyName: companyName, // Exists in DOM
        };
    },

    emits: ["clicked"],

    components: { CheckmarkSvg },

    computed: {
        ...mapState(useSubmissionWizardStore, [
            "bottom_navigation_rules",
            "gdpr_terms",
            "gdpr_privacy_policy",
            "show_gdpr_terms",
        ]),
        ...mapWritableState(useSubmissionWizardStore, [
            "highlight_incomplete_steps",
        ]),

        hasAgreedBoth() {
            return this.agree_terms && this.agree_privacy_policy;
        },

        modalTitle() {
            return this.companyName + ': ' + this.translate('Terms and Conditions / Privacy Policy');
        }
    },

    methods: {
        checkIfStepsCompleteAndSubmit() {
            if (this.bottom_navigation_rules.mandatory_steps_complete) {
                if (this.show_gdpr_terms) {
                    this.openTermsAndConditionsModal();
                } else {
                    this.$emit("clicked"); // Goes to next step
                }

                return;
            }

            this.saving = false;
            this.highlight_incomplete_steps = true;
            this.$swal({
                title: this.translate("Submission form incomplete!"),
                text: this.translate(
                    "Please fill in all the required steps before submitting the Manuscript.",
                ),
                icon: "warning",
                confirmButtonText: this.translate("Ok"),
                customClass: {
                    confirmButton: "btn btn-light-success",
                },
            });
        },

        hideModalAndGoToPreview() {
            this.hideModals();
            this.$emit("clicked");
        },

        openTermsAndConditionsModal() {
            jQuery("#dm-terms-and-conditions-modal").modal();
        },
    },
};
</script>
